var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcons8UserFolder1 = function SvgIcons8UserFolder1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.8,
    height: 14.24,
    viewBox: "0 0 17.8 14.24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6f6f6f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,8a2.013,2.013,0,0,0-2,2V20.238a2.013,2.013,0,0,0,2,2H19.8a2.013,2.013,0,0,0,2-2v-8.01a2.013,2.013,0,0,0-2-2H12.919L10.931,8.568h0A2.447,2.447,0,0,0,9.364,8ZM6,9.335H9.364a1.111,1.111,0,0,1,.712.258l2.175,1.812a.668.668,0,0,0,.428.155H19.8a.657.657,0,0,1,.668.668v8.01a.657.657,0,0,1-.668.668H6a.657.657,0,0,1-.668-.668V10A.657.657,0,0,1,6,9.335Zm6.9,3.115a1.78,1.78,0,1,0,1.78,1.78A1.78,1.78,0,0,0,12.9,12.45ZM10.429,16.9a.644.644,0,0,0-.644.644v.581c0,.989,1.262,1.89,3.115,1.89s3.115-.9,3.115-1.89v-.581a.644.644,0,0,0-.644-.644Z",
    transform: "translate(-4 -8)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcons8UserFolder1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons8-user-folder (1).dd93721f.svg";
export { ForwardRef as ReactComponent };